module.exports = __webpack_public_path__ + "static/media/spikesinfog.9c546870.jpg";